/**
 * Analytics Store Bridge Plugin
 * Makes Analytics Manager methods available in Vuex store actions
 */
export default ({ store, app }, inject) => {
  // Create analytics helper that can be used in store
  const analyticsHelper = {
    addToCart: (item) => {
      // Track via Analytics Manager only (GTM is now a provider)
      if (typeof window !== 'undefined' && window.$analytics) {
        window.$analytics.track('add_to_cart', {
          currency: item.currency || 'EUR',
          value: item.rates?.reduce((sum, rate) => sum + parseFloat(rate.amount), 0) || 0,
          items: [{
            item_id: String(item.id || item.room_type_id),
            item_name: item.unitCategoryName || item.room_type_name || item.name,
            affiliation: 'Direct Booking',
            currency: item.currency || 'EUR',
            discount: item.discount_amount || 0,
            item_category: 'Accommodation',
            item_category2: item.room_category || 'Room',
            price: item.rates?.reduce((sum, rate) => sum + parseFloat(rate.amount), 0) || 0,
            quantity: item.quantity || 1,
            start_date: item.start_date,
            end_date: item.end_date,
            nights: item.nights,
            guests: item.guests
          }]
        });
      }
    },

    removeFromCart: (item) => {
      // Track via Analytics Manager only (GTM is now a provider)
      if (typeof window !== 'undefined' && window.$analytics) {
        window.$analytics.track('remove_from_cart', {
          currency: item.currency || 'EUR',
          value: item.rates?.reduce((sum, rate) => sum + parseFloat(rate.amount), 0) || 0,
          items: [{
            item_id: String(item.id || item.room_type_id),
            item_name: item.unitCategoryName || item.room_type_name || item.name,
            affiliation: 'Direct Booking',
            currency: item.currency || 'EUR',
            item_category: 'Accommodation',
            price: item.rates?.reduce((sum, rate) => sum + parseFloat(rate.amount), 0) || 0,
            quantity: item.quantity || 1
          }]
        });
      }
    }
  };

  // Inject into store
  store.$analyticsHelper = analyticsHelper;

  // Also inject globally
  inject('analyticsHelper', analyticsHelper);
}